import { SidenavModel } from '../models/sidenav/sidenav.model';
import { SidenavStylingModel } from '../models/sidenav/sidenav-styling.model';

export const /** @type {?} */ SidenavTemplates = {
  defaultTemplate: {
    property: new SidenavModel({
      display: true,
      disable: false,
      contentId: '',
      leftSideId: '',
      rightSideId: '',
      leftSideMode: 'over',
      rightSideMode: 'over',
      fullHeight: false,
      leftSideWidth: '',
      rightSideWidth: '',
    }),
    style: new SidenavStylingModel({
      container: { class: '', dynamicClass: '' },
      content: { class: '', dynamicClass: '' },
      leftSide: { class: '', dynamicClass: '' },
      rightSide: { class: '', dynamicClass: '' }
    })
  }
}
